import { render, staticRenderFns } from "./SettingCampaign.vue?vue&type=template&id=a537716e&"
import script from "./SettingCampaign.vue?vue&type=script&lang=js&"
export * from "./SettingCampaign.vue?vue&type=script&lang=js&"
import style0 from "./SettingCampaign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports